<div class="page-container">

  <a mat-button
     routerLink="/statistics"
     [state]="{ restoreSearch: true }"
     class="back-button">
    <mat-icon>arrow_back</mat-icon>
    Volver al buscador
  </a>

  <div *ngIf="isLoading$ | async" class="main-loader-container">
    <mat-spinner diameter="60"></mat-spinner>
    <span>Cargando datos del partido...</span>
  </div>

  <div *ngIf="!(isLoading$ | async)" class="page-content">

    <app-match-detail-header
      [matchInfo]="matchInfo$ | async">
    </app-match-detail-header>

    <div class="grid-container">

      <app-match-goal-chronology
        class="grid-item"
        [chronology]="goalChronology$ | async"
        [matchInfo]="matchInfo$ | async">
      </app-match-goal-chronology>

      <app-match-player-stats
        class="grid-item"
        [playerStats]="playerStats$ | async"
        [matchInfo]="matchInfo$ | async">
      </app-match-player-stats>

      <app-match-events-list
        class="grid-item"

        [events]="matchEvents$ | async">
      </app-match-events-list>
    </div>



  </div>
</div>
